import cheader from '@/components/header/index.vue'

export default {
  name: 'quote_edit',
  data() {
    return {
      serverUrl: this.$store.state.config.serverUrl,
      order: {
        productList: [],
        pay: {},
        endValue: ''
      },
      orderBy:"",
      search: {
        name: '',
        range: 'default',
        accountPeriod:0,
        discount:100
      },
      pageNo:1,
      percent:0,
      progressFlag:false,
      pageSize:10,
      pageTotal:0,
      loadtext:"正在查询中,请稍后",
      loading:true,
      remark: '',
      timer:null,
      status:this.percent<100?"":"success",//进度条组件加上状态后不显示文字
      color:[
            {color:"#fdfdfd",percentage:99},
            {color:"#ccccc",percentage:100},
      ],
      pzhwhView: false,
      isExportExcelFlag: false
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
    goodsFilter() {
      return this.order.productList.filter((item) => {
        if (this.search.range === 'dgg') {
          return item.dgg != '0' && item.product.name.indexOf(this.search.name) != -1
        } else {
          return item.flag == this.search.range && item.product.name.indexOf(this.search.name) != -1
        }
      })
    },
    progressFormat(percentage){
      return percentage<100?"已上传("+percentage+"%)":"上传完成"
    },
    subGoods() {
      return this.order.productList.filter((item) => {
        return item.flag == 'default'
      })
    }
  },
  components: {
    cheader
  },
  created() {
    this.checkStatus()
  },
  methods: {
    calcDiscountPrice(item) {
      const ticket = Number(item.ticket || 0)
      const discount = Number(this.search.discount || 100)
      const rebate = Number(item.rebate || 0)
      item.discountPrice = (ticket * (discount / 100) * ((100 - rebate) / 100)).toFixed(3)
      item.product.discountPrice = item.discountPrice
      this.$set(item, 'discountPrice', item.discountPrice)
    },
    saveCount(){
      let params = {
        id: this.$route.params.id,
        userId: this.$store.state.user.id,
        accountPeriod: this.search.accountPeriod,
        discount: this.search.discount
      }
      this.$http.post(`/api/inquiry/pushAccount`, params).then((res) => {
          if (res.data.success) {
            console.log("保存成功!!!")
          } else {
            console.log("保存失败!!!")
          }
        })
      if(this.order.isDak==true||this.order.isDak=='true'){
        for (let item of this.order.productList) {
          this.calcDiscountPrice(item)
        }
        this.$forceUpdate()
      }
    },
    importQuoteTemplate(param){
        this.loading=false
        this.loadtext="正在处理中，请勿刷新"
        let formData = new FormData()
        formData.append('file', param.file)
        this.$http.post(`/api/excelUpload/enquiryProduct?userId=${this.$store.state.user.id}&id=${this.$route.params.id}`, formData).then((res) => {
          if (res.data.success) {
            this.$message({
              message: res.data.message,
              type: 'success'
            });
            //this.loading = false
            this.progressFlag=false
            clearInterval(this.timer)
            this.timer = null
            setTimeout(this.index, 1000);
          } else {
            this.loading = false
            this.$message.warning(res.data.message)
            this.progressFlag=false
            clearInterval(this.timer)
            this.timer = null
          }
        })
        var _this = this
        this.timer = setInterval(function(){
          _this.progress()
        },1000)
    },
    go(url) {
      this.$router.push(url)
    },
    checkdiscount(e){
      let val = e.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace(/^(\d*\.)(.*)$/, (m, a, b) => a + b.replace(/\./g, '')).replace(/^0+(\d)/, '$1')
      if (val === '.') val = '0.'
      this.search.discount = val
    },
    checkAccount(e){
      this.search.accountPeriod = e.replace(/[^\d]/g, '').replace(/^0+(\d)/, '$1')
    },
    checkStatus(){
      this.$http.get('/api/inquiry/getStatus', {
        params: {
          id: this.$route.params.id,
        }
      }).then((res) => {
        console.log(res.data.data)
        if(res.data.data==1){
          this.orderBy = "desc"
        }
        this.index()
      })
    },
    uploadTemplateNew(){
      this.loading = true
    },
    handleSizeChange(val){
      this.loading = true
      this.pageSize = val
      this.index()
    },
    searchInfo(){
      this.pageNo = 1
      this.index()
    },
    handlePageChange(val){
      this.loading = true
      this.pageNo = val
      this.index()
    },
    index() {
      this.loadtext="正在查询中,请耐心等待"
      this.loading = true
      var params = {
        id: this.$route.params.id,
        userId:  this.user.id,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        otherParam:this.search.name,
        orderBy: this.orderBy
      }
      this.$http.get('/api/inquiry/toApply', {
        params:params
      }).then((res) => {
        this.order = res.data.data
        this.loading = false
        switch (this.order.pay.value) {
          case 'cash':
            this.order.pay.value = '现金'
            break
          case 'card':
            this.order.pay.value = '银行卡'
            break
          case 'alipay':
            this.order.pay.value = '支付宝'
            break
          case 'wechat':
            this.order.pay.value = '微信'
            break
        } 
        for (let item of this.order.productList) {
          item.available = item.available ? item.available : item.expected
          item.ticket = item.ticket ? item.ticket : '0'
          item.unticket = item.unticket ? item.unticket : '0'
          item.discountPrice = item.discountPrice ? item.discountPrice : '0'
          this.$set(item, 'discountPrice', item.discountPrice)
          this.$set(item, 'flag', 'default')
        }
        this.isExportExcelFlag = this.order.productList.some(item => item.ckshl!='0' || item.pihao!='0' || item.scrq!='0' || item.yxq!='0')
        if(this.order.accountPeriod){
          this.$set(this.search,'accountPeriod',this.order.accountPeriod)
        }
        if(this.order.discount){
          this.$set(this.search,'discount',this.order.discount)
        }
        this.pageTotal = res.data.total
      })

    },
    importer() {
      this.loading=true
      this.$http.get('/api/inquiry/exportSupplierEnquiry', {
        params: {
          id: this.$route.params.id,
          userId: this.user.id
        }
      }).then((res) => {
        this.loading=false
        window.location.href = this.serverUrl + res.data.data
      })
    },
    exportInquiry() {
      this.$http.get('/api/inquiry/exportInquiry', {
        params: {
          id: this.$route.params.id,
          userId: this.user.id
        }
      }).then((res) => {
        window.location.href = this.serverUrl + res.data.data
      })
    },
    uploadTemplate(param) {
      this.loading=false
      this.loadtext="正在处理中，请勿刷新"
      let formData = new FormData()
      formData.append('file', param.file)
      this.$http.post(`/api/excelUpload/inquiryProduct?userId=${this.$store.state.user.id}&id=${this.$route.params.id}`, formData).then((res) => {
        if (res.data.success) {
          this.$message({
            message: res.data.message,
            type: 'success'
          });
          //this.loading = false
          this.progressFlag=false
          clearInterval(this.timer)
          this.timer = null
          setTimeout(this.index, 1000);
        } else {
          this.loading = false
          this.$message.warning(res.data.message)
          this.progressFlag=false
          clearInterval(this.timer)
          this.timer = null
        }
      })
      var _this = this
      this.timer = setInterval(function(){
        _this.progress()
      },1000)
    },
    progress(){
      this.$http.post(`/api/excelUpload/progress?userId=${this.$store.state.user.id}&id=${this.$route.params.id}`).then((res) => {
        if (res.data.success) {
          this.progressFlag=true
          this.percent = Number(res.data.message)
          
          if(res.data.message==100){
            this.progressFlag=false
            clearInterval(this.timer)
            this.timer = null
          }
        } else {
          
        }
      })
    },
    handleSuccess(response, file, fileList) {
      this.$message({
        message: "文件上传成功,正在处理中,请稍后刷新查看",
        type: 'success'
      });
      this.loading = false
      setTimeout(this.index, 1000);
    },
    editRebate(item){
      if(this.order.isDak==true||this.order.isDak=='true'){
        this.calcDiscountPrice(item)
      }
      this.$forceUpdate()
      this.$http.post('/api/inquiry/pushOffer', {
        id: this.$route.params.id,
        userId: this.user.id,
        goods: [item],
        remark: this.remark
      }).then((res) => {
        if (res.data.success) {
          this.$message({
            message: "操作成功",
            type: 'success'
          });
        } else {
          this.$message({
            message:res.data.message,
            type: 'error'
          });
        }
      })
    },
    editValue(subGoods,type){
      if(this.order.isDak==true||this.order.isDak=='true'){
        if(type=='ticket'){
          if(this.search.accountPeriod!=0&&this.search.accountPeriod==''){
            this.$message({
              message: "账期不能为空",
              type: 'success'
            });
            return
          }
          if(this.search.discount==''){
            this.$message({
              message: "整单折扣比例不能为空",
              type: 'success'
            });
            return
          }
          this.calcDiscountPrice(subGoods)
          subGoods.product.discount = this.search.discount
          subGoods.product.accountPeriod = this.search.accountPeriod
          subGoods.accountPeriod = this.search.accountPeriod
          subGoods.discount = this.search.discount
          this.$forceUpdate()
        }else if(type=='discountPrice'){
          if(this.search.accountPeriod!=0&&this.search.accountPeriod==''){
            this.$message({
              message: "账期不能为空",
              type: 'success'
            });
            return
          }
          if(this.search.discount==''){
            this.$message({
              message: "整单折扣比例不能为空",
              type: 'success'
            });
            return
          }
          subGoods.product.discountPrice = subGoods.discountPrice
          subGoods.product.discount = this.search.discount
          subGoods.product.accountPeriod = this.search.accountPeriod
          subGoods.accountPeriod = this.search.accountPeriod
          subGoods.discount = this.search.discount
        }

      }
      
      this.$http.post('/api/inquiry/pushOffer', {
        id: this.$route.params.id,
        userId: this.user.id,
        goods: [subGoods],
        remark: this.remark
      }).then((res) => {
        if (res.data.success) {
          this.$message({
            message: "操作成功",
            type: 'success'
          });
        } else {
          this.$message({
            message:res.data.message,
            type: 'error'
          });
        }
      })
    },
    save() {
      var _this = this
      this.$http.post('/api/inquiry/sendInquiryNotice', {
        id: this.$route.params.id,
        userId: this.user.id
      }).then((res) => {
        if (res.data.success) {
          this.$message({
            message: "操作成功",
            type: 'success'
          });
          setTimeout(function(res){
            _this.$router.push({
              path:"/inquiry/none"
            })
          },1000)
        }else{
          this.$message({
            message: "操作失败",
            type: 'success'
          });
        }
      })
      // this.$http.post('/api/inquiry/pushOffer', {
      //   id: this.$route.params.id,
      //   userId: this.user.id,
      //   goods: this.subGoods,
      //   remark: this.remark
      // }).then((res) => {
      //   if (res.data.success) {
      //     this.$alert(res.data.message, '', {
      //       confirmButtonText: '确定',
      //       callback: action => {
      //         this.$router.back()
      //       }
      //     })
      //   } else {
      //     this.$alert(res.data.message, '', {
      //       confirmButtonText: '确定',
      //       callback: action => {

      //       }
      //     })
      //   }
      // })
    },
    sortTable(){
       if(this.orderBy == "asc"){
         this.orderBy = "desc"
       }else{
         this.orderBy = "asc"
       }
       this.index()
    },
    oneClickQuote() {
      this.$confirm('确定一键进行报价?', '操作提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post('/api/inquiry/oneClickQuote', {
          id: this.$route.params.id,
          userId: this.user.id
        }).then((res) => {
          if (res.data.success) {
            this.$message({
              message: "报价成功",
              type: 'success'
            });

            this.index(this.page)
          } else {
            this.$message({
              message: "操作失败",
              type: 'error'
            });
          }
        });
      }).catch(() => {
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/home/quote/edit/index.js